module.exports = __webpack_public_path__ + "img/km.16b0a45c.svg";